import { getDisplayName, getPrincipalInitials } from '@AppModels/NameUtils';
import { css } from 'aphrodite';
import * as React from 'react';
import { IPrincipal } from '../../../../extViewmodels';
import { Avatar } from '../../../../web/components-v2/Avatar';
import { CrownGraphic } from '../../svgs/CrownGraphic';
import { styleSheet } from '../styles';

export type PodiumPosition = 'first' | 'second' | 'third';

const PLACE_NUMBER: Record<PodiumPosition, number> = { first: 1, second: 2, third: 3 };

const RING_STYLE = {
	first: styleSheet.podiumRingFirst,
	second: styleSheet.podiumRingSecond,
	third: styleSheet.podiumRingThird,
} as const;

const BADGE_STYLE = {
	first: styleSheet.podiumBadgeFirst,
	second: styleSheet.podiumBadgeSecond,
	third: styleSheet.podiumBadgeThird,
} as const;

interface IProps {
	isAsc?: boolean;
	position: PodiumPosition;
	userReference: IPrincipal;
}

export const Top3Avatar: React.FC<IProps> = ({ isAsc, position, userReference }) => {
	const isFirst = position === 'first';
	return (
		<li className={css(styleSheet.podiumPlace)}>
			{isFirst && <CrownGraphic className={css(isAsc && styleSheet.crownUpsideDown)} />}
			<div className={css(styleSheet.podiumRing, RING_STYLE[position])}>
				{/* Radix Avatar keeps its "image loaded" state across prop changes, which hides the initials when a
				    rep without a photo moves into a place a rep with one held; a key per rep resets it. */}
				<Avatar
					key={userReference.id}
					altText={getDisplayName(userReference)}
					fallbackText={getPrincipalInitials(userReference)}
					imgSrc={userReference.profilePic}
					styles={[isFirst ? styleSheet.podiumAvatarFirst : styleSheet.podiumAvatar]}
				/>
			</div>
			<span className={css(styleSheet.podiumBadge, BADGE_STYLE[position])}>{PLACE_NUMBER[position]}</span>
		</li>
	);
};

export const Top3AvatarGhost: React.FC = () => (
	<li aria-hidden='true' className={css(styleSheet.podiumPlace, styleSheet.podiumPlaceEmpty)}>
		<div className={css(styleSheet.podiumRing)}>
			<div className={css(styleSheet.podiumAvatar)} />
		</div>
	</li>
);
